import { Box } from '@mui/material';
import { EDITABLE_LIST_FIELD } from 'framework/list';
import { AnchorField, FormattedTextField } from 'framework/ui/field';
import { SanitizedHtml } from 'framework/utils';
import { EditActionField, LastUpdateField, ReviewActionField, StatusField } from './fields';
import { ProjectTeamMemberRoleField } from 'domain/shared/newProject';

type GridCellProps = Record<string, unknown>;

export const getAssumptionDescriptionCell = (gridCellProps: GridCellProps) => ({
  type: EDITABLE_LIST_FIELD,
  source: 'description',
  isEditor: false,
  component: FormattedTextField,
  componentProps: {
    label: '',
    format: (str: string) => (
      <Box
        sx={{
          wordBreak: 'break-word',
          '& p:first-of-type, & ul:first-of-type, & ol:first-of-type': { mt: 0 },
          '& p:last-of-type, & ul:last-of-type, & ol:last-of-type': { mb: 0 },
        }}
      >
        <SanitizedHtml html={str ?? ''} />
      </Box>
    ),
  },
  gridCellProps,
});

export const getAssumptionTableCells = () => [
  {
    type: EDITABLE_LIST_FIELD,
    source: 'number',
    isEditor: false,
    component: AnchorField,
    gridCellProps: { size: 0.5, justifyContent: 'center', display: 'flex' },
  },
  getAssumptionDescriptionCell({ size: 3.5 }),
  {
    type: EDITABLE_LIST_FIELD,
    source: 'assignedRole',
    isEditor: false,
    component: ProjectTeamMemberRoleField,
    componentProps: { color: 'error.dark', label: 'Role' },
    gridCellProps: { size: 2 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'status',
    isEditor: false,
    component: StatusField,
    gridCellProps: { size: 2, sx: { minWidth: 140, flexShrink: 0 } },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'updatedAt',
    isEditor: false,
    component: LastUpdateField,
    componentProps: { createSource: 'createdAt' },
    gridCellProps: { size: 2, sx: { minWidth: 110, flexShrink: 0 } },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'id',
    isEditor: false,
    component: ReviewActionField,
    gridCellProps: { size: 1.5 },
  },
  {
    type: EDITABLE_LIST_FIELD,
    source: 'id',
    isEditor: false,
    component: EditActionField,
    gridCellProps: { size: 0.5 },
  },
];
